import { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { getPropertyByPath, setPropertyByPath } from '../../utils/objects';
import getComponentInstancePathMappingByIds from './getComponentInstancePathMappingByIds';

export default function editComponentInstanceById(
  rootComponent: ComponentInstance,
  componentId: string,
  edit: (instance: ComponentInstance) => ComponentInstance,
): ComponentInstance {
  const componentInstancePathsById = getComponentInstancePathMappingByIds(rootComponent);
  const componentInstancePath = componentInstancePathsById[componentId];
  if (!componentInstancePath) {
    // Component not found => no changes
    return rootComponent;
  }
  const oldComponentInstance = getPropertyByPath(rootComponent, componentInstancePath) as ComponentInstance;
  const newComponentInstance = edit(oldComponentInstance);
  if (oldComponentInstance === newComponentInstance) {
    // No changes => no need to update
    return rootComponent;
  }
  return setPropertyByPath(rootComponent, componentInstancePath, newComponentInstance);
}
